import React from 'react';
import { Container } from '@material-ui/core';

import aquavitalBanner from '../../../assets/images/banner.jpg';
import css from './Banner.module.css';

const Banner = () => (
    <Container>
        <div className={css.Banner}>
            <img src={aquavitalBanner} alt="AquavitalBanner" />
        </div>
    </Container>
);

export default Banner;